import { render, staticRenderFns } from "./TiptapMenu.vue?vue&type=template&id=306513ff"
import script from "./TiptapMenu.vue?vue&type=script&lang=ts"
export * from "./TiptapMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports